<div class="login-page">
    <img src="../../../assets/images/login-page-image/Background_Competency.jpg" alt="Competencylogin"
      class="img-fluid login_background_image">
    <div class="container position-absolute login-container">
      <div class="row">
        <div class="col-md-5 offset-md-8">
          <a class="img-fluid"><img src="../../../assets/images/login-page-image/Innova_logo.svg" alt="Innova_logo"></a>
          <div class="pt-5 login-title" [@revealAnimation]>
            GLOBAL SOLUTIONS DELIVERY
          </div>
          <div class="pt-2 login-title-1" [@revealAnimation]>
            LOGIN ISSUE?
          </div>
          
          <div class="pt-2 login-description" [@revealAnimation]>
            We regret any inconvenience caused, as it appears there might be a login issue currently. Our team is actively working to resolve this matter promptly.
          </div>
          <div class="pt-2 login-description" [@revealAnimation]>
            For immediate assistance, please reach out to our support team via the email provided below.
          </div>
          <div class="pt-2 email-text" [@revealAnimation]>
            <a href="https://outlook.office.com/mail/deeplink/compose?to=gsd-support@innovasolutions.com" target="_blank" >gsd-support@innovasolutions.com</a>
          </div>
  
        </div>
  
  
      </div>
  
  
    </div>
  </div>